export default __webpack_public_path__ + "static/media/auth-forgot.a817224e.png";